import React from "react";
import request from "../../../utilities/requests";
import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Typography,
  ListItemAvatar,
  Avatar
} from "@mui/material";
import EventDialog from "./EventDialog";
import formatDate from "../../../utilities/formatDate";

const AllEvents = ({ user }) => {
  const [events, setEvents] = React.useState([]);
  const [orgData, setOrgData] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [selectedEvent, setSelectedEvent] = React.useState(null);

  React.useEffect(() => {
    if (!loaded) {
      getAllEvents();
      setLoaded(true);
    }
  });

  const getAllEvents = async () => {
    const result = await request("events?unlisted=true");

    if (result.success) {
      setEvents(result.events);
      if (result?.orgData) {
        setOrgData(result.orgData);
      }
    }
  };

  const getLogo = (event) => {
    const org = event?.org;
    if (!org) {
      return <></>;
    }
    const logo = orgData[org].logo;
    return (
      <ListItemAvatar>
        <Avatar src={logo} />
      </ListItemAvatar>
    );
  };

  const handleClickOpen = (event) => {
    setSelectedEvent(event);
    setOpen(true);
  };

  const handleClose = () => {
    getAllEvents();
    setOpen(false);
    setSelectedEvent(null);
  };

  return (
    <Grid container flexDirection="column">
      <List>
        {events.map((event) => {
          return (
            <div key={event._id}>
              <ListItem>
              {orgData ? getLogo(event) : <></>}
                <ListItemButton onClick={() => handleClickOpen(event)}>
                  {/* <ListItemText primary={`${event.name} | ${formatDate(event.date)}`} secondary={event.eventType}/> */}
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography>{event.name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2">
                        {formatDate(event.date)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="button">
                        {event.eventType}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItemButton>
              </ListItem>
              <Divider />
            </div>
          );
        })}
      </List>
      <EventDialog open={open} close={handleClose} event={selectedEvent} />
    </Grid>
  );
};

export default AllEvents;
